module.exports = __webpack_public_path__ + "img/20180815_150119_064.341c9b99.jpg";